export class MathUtils {
  static calculateDiscount(discount: number, total: number): number {
    return Math.round((discount * 100) / total);
  }

  static checkIfNumeric(value: any): boolean {
    return value != null && !isNaN(value);
  }
}
